
























import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FeeSheetTemplatesGrid from '../components/fee-sheet-templates/fee-sheet-templates-grid.vue';
import { DxPopup, DxButton } from 'devextreme-vue';

@Component({
  components: {
    PageTitle,
    FeeSheetTemplatesGrid,
    DxPopup,
    DxButton
  }
})
export default class FeeSheetTemplates extends Vue {
  $refs: Vue['$refs'] & {
    feeSheetTemplatesGrid?: FeeSheetTemplatesGrid;    
  } = {};

  deleteVisible: boolean = false;

  constructor() {
    super();
  }

  showDelete(): void {
    this.deleteVisible = true;
  }

  hideDelete(): void {
    this.deleteVisible = false;
  }

  deleteFeeSheetTemplate(): void {
    (this.$refs.feeSheetTemplatesGrid as any).deleteFeeSheetTemplate();
    this.hideDelete();
  }
}
